Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.ClippingChannelView extends Settings.Views.Topics.ChannelView
  sourceClassName: 'Keepcon::ClippingSource'
  channelClassName: 'Keepcon::ClippingChannel'
  sourceIcon: image_path('clipping.png')
  template: JST['backbone/templates/settings/topics/clipping_channel']

  initialize: ({sourceId, sourceIndex, allowRemove}) ->
    @sourceId = sourceId
    @sourceIndex = sourceIndex
    @allowRemove = allowRemove

  render: ->
    @$el.html @template
      id: @sourceId
      name: Date.now()
      index: @sourceIndex
      allowRemove: @allowRemove
      sourceClassName: @sourceClassName
      sourceIcon: @sourceIcon
      channelClassName: @channelClassName
    @
